import React from 'react';
import ReactDOM from 'react-dom/client';
import { ForAthlete } from './ForAthlete';
import type { BrandPromo, Faq, Intro, Slide, Step, Testimonials } from './slides';

type PageData = {
    csrfToken: string;
    slides: Slide[];
    intro: Intro;
    steps: Step[];
    brandPromo: BrandPromo;
    testimonials: Testimonials;
    faq: Faq;
};

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('for-athlete-root');
if (!container) { throw new Error('Missing #for-athlete-root element'); }
const root = ReactDOM.createRoot(container);
root.render(React.createElement(ForAthlete, pageData));

if (module.hot) { module.hot.accept(); }
